module.exports = __webpack_public_path__ + "img/mega-thumb-1.353ab092.png";